<template>
  <v-container class="ordem-do-dia">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form ref="form">
        <PageTitle
          icon="mdi-pencil-box-outline"
          main="Atividades Legislativas"
          sub="Ordem do dia"
          home='/Legislativo'
        />
        <div>
          <formulario />
        </div>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Formulario from '../ordendodia/index.vue'
// import Stat from './Stat'
// import axios from 'axios'
// import { baseApiUrl } from '../../global'
export default {
  name: 'OrdemDoDia',
  components: { PageTitle, Formulario },
  data: () => ({
  })
}
</script>

<style scoped>
</style>
